<template lang="pug">
#NavBar
  b-navbar(variant="white" style="height: 80px;")
    //- img(v-if="mostrar" src="../../../public/logo-main-clasworld.png" style="height:50px; margin:5px")
    h2(v-if="mostrar").title PYG CONTABILIDAD
    button.boton#boton(v-if="mostrar" @click="show")
      b-icon(icon="list" style="width: 40px; height: 40px;" class="rounded-circle bg-secondary p-2" variant="light")
    b-navbar-nav(class="ml-auto")
      .d-flex.flex-column
        .text-right
          b-nav-item-dropdown(right)
            template(v-slot:button-content)
              span#UserName {{fullName}}
            b-dropdown-item(@click="logout") 
              font-awesome-icon.sesion-item(:icon="['fas', 'sign-out-alt']" size="lg" style="margin-right:5px; color:#212121" )
              span.sesion-item(style="color:#212121")  Cerrar Sesión
        small {{ groupList }}
  b-navbar-nav.menu#menu(vertical)
    //- img(src="../../../public/logo-main-clasworld.png" style="width:170px; margin: -15px 0px 5px -8px;")
    h2.title-vertical PYG
    h2.title-vertical CONTABILIDAD
    b-icon.btn-hide-menu(@click="show" icon="list" style="width: 40px; height: 40px;" class="rounded-circle bg-secondary p-2" variant="light")
    .contenido
      b-nav-item.item(:to="'/'" exact)
        font-awesome-icon.imagen.item(:icon="['fas', 'home']" size="lg")
        span.item() Inicio

      b-nav-item.item(v-if="user.role==='owner'" :to="'/usuarios'")
        font-awesome-icon.imagen.item(:icon="['fas', 'users']" size="lg")
        span.item Usuarios

      b-nav-item.item(v-if="user.role==='owner'" :to="'/servicios'")
        font-awesome-icon.imagen.item(:icon="['fas', 'briefcase']" size="lg")
        span.item Servicios

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/empresas'")
        font-awesome-icon.imagen.item(:icon="['far', 'building']" size="lg")
        span.item Empresa

      b-nav-item.item(v-if="checkRole(['owner'])" :to="'/grupos-empresas'")
        font-awesome-icon.imagen.item(:icon="['fas', 'city']" size="lg")
        span.item Grupos

      b-nav-item.item(v-if="user.role==='owner'" :to="'/tareas'")
        font-awesome-icon.imagen.item(:icon="['fas', 'thumbtack']" size="lg")
        span.item Tareas

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/seguimiento-tareas'")
        font-awesome-icon.imagen.item(:icon="['fas', 'tasks']" size="lg") 
        span.item Seguimiento de tareas

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/documentos'")
        font-awesome-icon.imagen.item(:icon="['fas', 'cloud-upload-alt']" size="lg")
        span.item Documentos

      b-nav-item.item(v-if="checkRole(['owner']) || user.allowCalendarView" :to="'/calendario'")
        font-awesome-icon.imagen.item(:icon="['far', 'calendar-alt']" size="lg" )
        span.item Calendario

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/notas'")
        font-awesome-icon.imagen.item(:icon="['far', 'sticky-note']" size="lg")
        span.item Notas
      
      b-nav-item.item(v-if="checkRole(['owner'])" :to="'/email'")
        font-awesome-icon.imagen.item(:icon="['fas', 'envelope']" size="lg")
        span.item Email
</template>

<script>
import { mapActions ,mapGetters} from 'vuex'
export default {
  data() {
    return {
      fullName: '',
      groupList: '',
      mostrar: true
    }
  },
  created() {
    this.getUser();
  },
  destroyed(){
    document.getElementById('app').style.marginLeft='0'
    document.getElementById('app').style.transition='none'
  },
  methods: {
    ...mapActions('AuthenticationStore', ['logout']),
    ...mapActions('UserStore', ['getMyUser']),
    async getUser(){
      const user = await this.getMyUser();
      this.fullName = `${user.name} ${user.lastName}`;
      this.groupList = user.businessGroups.map(bg => bg.name).join(', ');
    },
    show(){
      if(this.mostrar){
        if (!this.inMobile()) {
          document.getElementById('app').style.marginLeft='250px'
        }
        document.getElementById('menu').style.marginLeft='250px'
        document.getElementById('app').style.transition='0.3s'
        this.mostrar=false
      } else {
        document.getElementById('menu').style.marginLeft='-250px'
        document.getElementById('app').style.marginLeft='0'
        document.getElementById('app').style.transition='0.3s'
        this.mostrar=true
      }
    },
    checkRole (roles) {
      return roles.includes(this.user.role)
    },
    inMobile () {
      return 700 > Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    }
  },
  computed:{
    ...mapGetters('AuthenticationStore', ['user'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/colors.scss';
#UserName{
  color: $text-dark;
  font-weight: bold;
}

.title{
  color: $text-dark;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
  margin-bottom: 0px;
}

.title-vertical{
  color: $text-dark;
  font-weight: bold;
  text-align: left;
  font-size: 20px;
  margin-bottom: 0px;
}

#menu {
  z-index: 99;
  background:white;
  height: 100%;
  width: 250px;
  position: fixed;
  top:0;
  left: -250px;
  padding: 20px;
  transition: 0.3s;
  box-shadow: 0px 3px 6px #00000029
}
.btn-hide-menu {
  position: absolute;
  z-index: 100;
  top: 20px;
  right: 16px;
}
.boton{
  position: relative;
  background: transparent;
  border-color: transparent;
}
.boton:hover{
  background: transparent;
  border-color: transparent;
}
.boton:focus{
  outline: none;
}
.contenido {
  font-size: 14px;
  height: 32px;
  margin: 90px 0px 0px -19px;
}
.item{
  color:$text-dark;
;
//  text-decoration: none;
}
.item:hover{
  background: var(--primary) ;
  padding: 0;
  border-radius: 0px 5px 5px 0px;
}
b-nav-item:active{
  background:var(--primary);
  padding: 0;
  border-radius: 0px 5px 5px 0px;
}
.imagen{
  width: 21px;
  margin-right: 10px;
  margin-left: 17px;
}
.sesion-item{
  color:var(--primary);
  font-size: 15px;
}
.router-link-active{
  background: var(--primary) !important;
  border-radius: 0px 5px 5px 0px;
}

</style>
